import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { PeriodReport } from 'api/periodReports/type';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface TrapConnectivityGapsProps {
  trapType: TrapType;
  data?: PeriodReport;
}

const TrapConnectivityGaps = ({ trapType, data }: TrapConnectivityGapsProps) => {
  const { t } = useTranslation();
  const filteredData = data?.trap_data_list.filter(trap => trap.trap_type === trapType) || [];
  return (
    <div className="row mt-2">
      <div className="row text-center">
        <h5>
          {t('EcnounterList.pdf-title.report')}{' '}
          <strong>
            "
            {trapType === TrapType.MCT
              ? t('TrapsDataList.titleMCT')
              : trapType === TrapType.SMST
                ? t('TrapsDataList.titleSMST')
                : t('TrapsDataList.titleSRST')}
            "
          </strong>
        </h5>
      </div>
      <div className="row">
        <div className="mx-0 px-0">
          <table className="table table-bordered dt-responsive nowrap table-striped table-sm table-hover align-middle">
            <thead className="">
              <tr>
                <th className="text-center" scope="col">
                  {t('TrapsDataList.accordion.accordion-inner.sequence-number')}
                </th>
                <th className="text-center" scope="col">
                  {t('TrapsDataList.accordion.accordion-inner.serial-number')}
                </th>
                <th className="text-center" scope="col">
                  {t('TrapsDataList.accordion.accordion-inner.last-monitoring-msg')}
                </th>
                <th className="text-center" scope="col">
                  {t('TrapsDataList.accordion.accordion-inner.next-recieved-msg')}
                </th>
                <th className="text-center" scope="col">
                  {t('TrapsDataList.accordion.accordion-inner.lost-msgs')}
                </th>
              </tr>
            </thead>
            <tbody className="list form-check-all" id="trap_table">
              {filteredData.length === 0 ? (
                <tr className="align-content-center">
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                  <td className="text-center">-</td>
                </tr>
              ) : (
                filteredData.map(trap => (
                  <tr className="align-content-center">
                    <td className="text-center">{trap.trap_number}</td>
                    <td className="text-center">{trap.serial_number}</td>
                    <td className="text-center">{dayjs(trap.offline_start).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')}</td>
                    <td className="text-center">{dayjs(trap.offline_end).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm')}</td>
                    <td className="text-center">{trap.lost_msgs}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TrapConnectivityGaps;
